import React from 'react';
import Bag from './Bag';
const BagS = ({ color, ...props }) => (React.createElement(Bag, Object.assign({ color: color, size: 24 }, props)));
BagS.displayName = 'BagS'; // Fix for tsc
export default BagS;
//# sourceMappingURL=BagS.js.map